var event = require("./single.js")

module.exports = multiple

function multiple(names) {
    return names.reduce(function (acc, name) {
        acc[name] = event()
        return acc
    }, {})
}



//////////////////
// WEBPACK FOOTER
// ./~/geval/multiple.js
// module id = 134
// module chunks = 0